import axios from "axios"

export const getFeaturesByTenantId = async (id) => {
    try {
        const res = await axios.get(`/api/Company/getTenantFeature/${id}`)
        return res
    } catch (error) {
        console.log('error fetching', error.message)
    }
}